import axios from 'axios'
import cookie from "react-cookies";

// 统一配置 axios
const request = axios.create({
  baseURL: process.env.REACT_APP_URL, // url = base url + request url
  timeout: 50000, // request timeout
})


// request 拦截器
// 添加请求拦截器
request.interceptors.request.use(config => {
  const token = cookie.load("token")
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  // 在最后必须return config
  return config
})
// response 拦截器


export default request
